import React, { useState, useEffect } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";

import { DropdownComponent } from "../dropdown_component";

import { Row, Col, FormLabel } from "react-bootstrap";

import api from "../../../service/api";
import { ErrorLog, Log } from "../../../helpers/logs";

export default function PreferencesModal(props) {
  const { show, hide, currentUser, InitializeUser } = props;
  const { user_preference } = currentUser;

  const [registries, setRegistries] = useState([]);
  const [locations, setLocations] = useState([]);
  const [physicians, setPhysicians] = useState([]);

  const [physLoaded, setPhysLoaded] = useState(0);
  // Default the form values
  const [enableTabView, setEnableTabView] = useState(
    user_preference.enable_tab_view,
  );
  const [enableTableType, setEnableTableType] = useState(
    user_preference.enable_patient_table == undefined
      ? false
      : user_preference.enable_patient_table,
  );
  const [preferredLocation, setPreferredLocation] = useState({
    value: user_preference.preferred_client_id,
    label: "Select a Location",
  });
  const [preferredRegistry, setPreferredRegistry] = useState({
    value: user_preference.preferred_registry_id,
    label: "Select a Registry",
  });

  const [preferredPhysician, setPreferredPhysician] = useState({
    value: user_preference.preferred_physician_id,
    label: "Select a Provider",
  });

  useEffect(() => {
    if (show) {
      setPhysLoaded(0);
      getData();
    }
  }, [show]);

  useEffect(() => {
    if (preferredLocation.value != null && locations.length > 1) {
      getPhysicians();
      getRegistries(locations);
    } else if (preferredLocation.value == null && locations.length > 1) {
      console.log("Resetting: ");
      setPhysicians([{ value: null, label: "Select a Provider" }]);
      setPreferredPhysician({
        value: null,
        label: "Select a Provider",
      });

      setRegistries([{ value: null, label: "Select a Registry" }]);
      setPreferredRegistry({
        value: null,
        label: "Select a Registry",
      });
    }
  }, [preferredLocation, locations]);

  async function getData() {
    // Currently disabled because low data causes the screen to flash too quickly between
    // the loader an the modal
    //$(`#loader`).show();

    var tempLocations = await getLocations();

    await getRegistries(tempLocations);

    //$(`#loader`).hide();
  }

  async function getLocations() {
    return await api.IConnectApi.getLocations()
      .then((response) => {
        var cli = [];

        cli = response.client_locations.map((cl) => {
          cl.label = cl.name;
          cl.value = cl.id;

          return cl;
        });

        if (preferredLocation.value != null) {
          var tempLocation = Object.assign(
            {},
            cli.find((x) => x.id == preferredLocation.value),
          );

          if (tempLocation.id !== undefined) {
            tempLocation.value = tempLocation.id;
            tempLocation.label = tempLocation.name;

            setPreferredLocation(tempLocation);
          }
        }

        cli.unshift({ value: null, label: "Select a Location" });

        setLocations(cli);

        return cli;
      })
      .catch((er) => {
        ErrorLog(`Er: `, er);
      });
  }

  async function getPhysicians() {
    if (
      locations.find((x) => x.value == preferredLocation.value) == undefined
    ) {
      setPhysicians([{ value: null, label: "Select a Provider" }]);
      setPreferredPhysician({
        value: null,
        label: "Select a Provider",
      });

      return;
    }

    await api.IConnectApi.getPhysicians(preferredLocation.value)
      .then((response) => {
        var phy = [];

        phy = response.physicians.map((p) => {
          p.label = p.display_name;
          p.value = p.id;

          return p;
        });

        if (preferredPhysician.value != null) {
          var tempPhysician = Object.assign(
            {},
            phy.find((x) => x.id == preferredPhysician.value),
          );
          tempPhysician.value = tempPhysician.id;
          tempPhysician.label = tempPhysician.display_name;

          setPreferredPhysician(tempPhysician);
        }

        phy.unshift({ value: null, label: "Select a Provider" });

        if (physLoaded === 1) {
          setPreferredPhysician({
            value: null,
            label: "Select a Provider",
          });
        } else {
          setPhysLoaded(physLoaded + 1);
        }

        setPhysicians(phy);
      })
      .catch((er) => {
        ErrorLog(`Er: `, er);
      });
  }

  async function getRegistries(tempLocations) {
    var sendValue = preferredLocation.value;

    if (sendValue == undefined || sendValue == null) {
      setRegistries([{ value: null, label: "Select a Registry" }]);
      setPreferredRegistry({
        value: null,
        label: "Select a Registry",
      });

      return;
    }

    if (locations.find((x) => x.value == sendValue) == undefined) {
      setRegistries([{ value: null, label: "Select a Registry" }]);
      setPreferredRegistry({
        value: null,
        label: "Select a Registry",
      });

      return;
    }

    await api.IConnectApi.GetAllRegistries(sendValue)
      .then((response) => {
        var reg = [];

        reg = response.registries.map((rg) => {
          rg.label = rg.name;
          rg.value = rg.id;

          return rg;
        });

        if (preferredRegistry.value != null) {
          var tempRegistry = Object.assign(
            {},
            reg.find((x) => x.id == preferredRegistry.value),
          );

          if (tempRegistry.id == undefined) {
            setPreferredRegistry({
              value: null,
              label: "Select a Registry",
            });
          } else {
            tempRegistry.value = tempRegistry.id;
            tempRegistry.label = tempRegistry.name;

            setPreferredRegistry(tempRegistry);
          }
        }

        reg.unshift({ value: null, label: "Select a Registry" });

        setRegistries(reg);
      })
      .catch((er) => {
        ErrorLog("Er: ", er);
      });
  }

  function handleSubmit() {
    var newPreferences = {
      enable_tab_view: enableTabView,
      preferred_client_id: preferredLocation.value,
      preferred_physician_id: null,
      preferred_registry_id: preferredRegistry.value,
      enable_patient_table: enableTableType,
      preferred_physician_id: preferredPhysician.value,
    };

    api.UserPrefernces.updateUserPreferences(newPreferences)
      .then((response) => {
        hide();

        InitializeUser();

        window.location.reload();
      })
      .catch((er) => {
        ErrorLog("Er: ", er);
      });
  }

  function handleClose() {
    hide();
  }

  return (
    <div>
      <Dialog
        lg={{
          "& .MuiDialog-paper": {
            maxWidth: "40%",
            height: `50% !important`,
            maxHeight: `50% !important`,
          },
        }}
        maxWidth="lg"
        open={show}
        onClose={hide}
        fullWidth
      >
        <DialogTitle>User Preferences</DialogTitle>
        <DialogContent
          style={{
            height: `25rem`,
            maxHeight: `25rem`,
            overflowY: `inherit !important`,
          }}
        >
          <ModalBody
            registries={registries}
            locations={locations}
            enableTabView={enableTabView}
            setEnableTabView={setEnableTabView}
            preferredLocation={preferredLocation}
            setPreferredLocation={setPreferredLocation}
            preferredRegistry={preferredRegistry}
            setPreferredRegistry={setPreferredRegistry}
            enableTableType={enableTableType}
            setEnableTableType={setEnableTableType}
            preferredPhysician={preferredPhysician}
            setPreferredPhysician={setPreferredPhysician}
            physicians={physicians}
          />
        </DialogContent>
        <ModalFooter
          handleClose={handleClose}
          hide={hide}
          handleSubmit={handleSubmit}
        />
      </Dialog>
    </div>
  );
}

function ModalBody(props) {
  const {
    registries,
    locations,
    enableTabView,
    setEnableTabView,
    preferredLocation,
    setPreferredLocation,
    preferredRegistry,
    setPreferredRegistry,
    enableTableType,
    setEnableTableType,
    preferredPhysician,
    setPreferredPhysician,
    physicians,
  } = props;

  return (
    <Row>
      <Col lg={6} style={{ marginTop: `2rem` }}>
        <FormLabel>Preferred Location</FormLabel>
        <DropdownComponent
          id="dropdown_component_id_clients"
          propkey="dropdown_component_id_clients"
          dropdownArray={locations}
          handleChangeFunc={setPreferredLocation}
          selectedOption={preferredLocation}
          searchable={true}
          placeholder="Preferred Location"
          isMulti={false}
          isDisabled={false}
          autoFocus={false}
        />
      </Col>
      <Col lg={6} style={{ marginTop: `2rem` }}>
        <FormLabel>Preferred Provider</FormLabel>
        <DropdownComponent
          id="dropdown_component_id_physicians"
          propkey="dropdown_component_id_physicians"
          dropdownArray={physicians}
          handleChangeFunc={setPreferredPhysician}
          selectedOption={preferredPhysician}
          searchable={true}
          placeholder="Preferred Physician"
          isMulti={false}
          isDisabled={physicians.length === 0}
          autoFocus={false}
        />
      </Col>
      <Col lg={6} style={{ marginTop: `2rem` }}>
        <FormLabel>Preferred Registry</FormLabel>
        <DropdownComponent
          id="dropdown_component_id_registries"
          propkey="dropdown_component_id_registries"
          dropdownArray={registries}
          handleChangeFunc={setPreferredRegistry}
          selectedOption={preferredRegistry}
          searchable={true}
          placeholder="Preferred Registry"
          isMulti={false}
          isDisabled={false}
          autoFocus={false}
        />
      </Col>
      <Col lg={6} />
      <Col lg={6} style={{ marginTop: `2rem` }}>
        <FormGroup style={{ zIndex: `999999999999 !important` }}>
          <FormControlLabel
            control={<Switch />}
            label="Registry Tab View"
            aria-label={`Registry Tab View`}
            checked={enableTabView}
            onChange={() => setEnableTabView(!enableTabView)}
          />
        </FormGroup>
      </Col>
      <Col lg={6} style={{ marginTop: `2rem` }}>
        <FormGroup style={{ zIndex: `999999999999 !important` }}>
          <FormControlLabel
            control={<Switch />}
            label="Registry Table Patient View"
            aria-label={`Registry Table Patient View`}
            checked={enableTableType}
            onChange={() => setEnableTableType(!enableTableType)}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

function ModalFooter(props) {
  const { handleClose, hide, handleSubmit } = props;

  return (
    <DialogActions>
      <Button onClick={hide}>Cancel</Button>
      <Button onClick={handleSubmit}>Submit</Button>
    </DialogActions>
  );
}
